var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import RecentOrderItem from "./RecentOrderItem";
import BaseModel from "@/models/BaseModel";
import DeliveryDetails from "@/models/DeliveryDetails";
import * as _ from 'lodash';
import { calculateTotal } from "@/utils/helper.functions";
var RecentOrderModel = /** @class */ (function (_super) {
    __extends(RecentOrderModel, _super);
    function RecentOrderModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.billAmount = hydrated.billAmount;
        _this.closedDate = hydrated.closedDate;
        _this.crDate = hydrated.crDate;
        _this.promiseDate = hydrated.promiseDate;
        _this.purchaseDate = hydrated.purchaseDate;
        _this.deliveryDetails = hydrated.deliveryDetails;
        _this.items = hydrated.items;
        _this.itemsOutOfStock = hydrated.itemsOutOfStock;
        _this.locationBase = hydrated.locationBase;
        _this.orderNotes = hydrated.orderNotes;
        _this.serviceType = hydrated.serviceType;
        _this.status = hydrated.status;
        _this.scriptId = hydrated.scriptId;
        _this.totals = hydrated.totals;
        _this.pickupDelay = hydrated.pickupDelay;
        _this.itemTotal = hydrated.itemTotal;
        _this.totals.total = calculateTotal(hydrated.totals);
        return _this;
    }
    RecentOrderModel.prototype.addRecentOrderItem = function (data) {
        this.items.push(new RecentOrderItem(data));
    };
    // current market value
    RecentOrderModel.prototype.getCurrentRecentOrderValue = function () {
        return _.reduce(this.items, function (accum, item) {
            var isBundle = (item.bundle);
            if (isBundle) {
                return accum + item.bundle.getBundleTotal();
            }
            return accum + item.getItemTotal();
        }, 0);
    };
    RecentOrderModel.prototype.hydrate = function (data) {
        var hydrated = {};
        hydrated.id = data.order_id || data.id || null;
        hydrated.billAmount = data.bill_amount || null;
        hydrated.closedDate = data.closed_date || null;
        hydrated.crDate = data.cr_date || null;
        hydrated.purchaseDate = (data.purchase_date) ? new Date(data.purchase_date * 1000) : null;
        hydrated.promiseDate = data.promise_date || null;
        hydrated.deliveryDetails = (data.delivery_details) ? new DeliveryDetails(data.delivery_details) : null;
        hydrated.items = data.items || [];
        hydrated.itemsOutOfStock = (data.hasOwnProperty("itemsOutOfStock")) ? data.itemsOutOfStock : false;
        hydrated.locationBase = data.location_base || null;
        hydrated.orderNotes = data.order_notes || "";
        hydrated.scriptId = data.script_id || null;
        hydrated.serviceType = parseInt(data.service_type) || null;
        hydrated.status = parseInt(data.status) || null;
        hydrated.totals = {};
        if (data.totals) {
            for (var key in data.totals) {
                hydrated.totals[_.camelCase(key)] = parseInt(data.totals[key]);
            }
        }
        hydrated.itemTotal = data.total || null;
        hydrated.pickupDelay = data.pickup_delay;
        return hydrated;
    };
    RecentOrderModel.prototype.getOrderStatus = function () {
        var itemStatus = 0;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            var currentStatus = parseInt(item.status);
            if (itemStatus < currentStatus) {
                itemStatus = currentStatus;
            }
        }
        return itemStatus;
    };
    RecentOrderModel.prototype.setOrderStatus = function (status) {
        if (status === void 0) { status = null; }
        this.status = (status !== null) ? status : this.getOrderStatus();
    };
    return RecentOrderModel;
}(BaseModel));
export default RecentOrderModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/RecentOrderModel.ts
// module id = 7jrD
// module chunks = 18